import { NotificationsContext } from "@ui-components/Notifications";
import {useContext, useState} from "react";
import useAsyncError from "@hooks/useAsyncError";
import {useIntl} from "react-intl";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";

export const KCC_PAYLOAD_MAPPINGS: {[key: string]: string} = {
  color: 'cod_color',
  system: 'cod_system',
  surface: 'val_surface',
  primers: 'lst_primers',
  reti: 'lst_reti',
  rasanti: 'lst_rasanti',
}

export const useKccResults = () => {

  // context
  const intl = useIntl();
  const {push} = useContext(NotificationsContext);

  // hooks
  const countryApiRequest = useCountryAxiosInstance();
  const throwError = useAsyncError();

  // state
  const [loading, setLoading] = useState(false);

  // utilities
  const convertResponses = (responses: {[key: string]: any}) => {
    const x = Object.entries(responses).reduce(
      (prev, [k, v]) => ({
        ...prev,
        [KCC_PAYLOAD_MAPPINGS[k]]: v ?? (['primers', 'reti', 'rasanti'].includes(k) ? [] : null)
      }),
      {}
    );
    delete x[undefined]
    return x;
  }

  // handlers
  const recompute = async (
    responses: {[key: string]: any},
    isTintometristService: boolean,
    surveyId?: number,
  ) => {
    setLoading(true);
    try {
      const payload = {
        ...convertResponses(responses),
        cod_survey: surveyId,
        is_tintometrist_version: isTintometristService,
      }
      return await countryApiRequest!.post("/tintometers/optimization_result", payload);
    }
    catch (e) {
      push({type: "error", title: intl.formatMessage({id: "server_error"}), message: "KCC_COMPUTATION_ERROR"});
      throwError(e);
    }
    finally {
      setLoading(false);
    }
  }

  return {recompute, loading};
}